export default function GlassCard({ children, className = "" }) {
  return (
    <div className={`
      sm:backdrop-blur-md sm:bg-white/10 
      sm:border sm:border-white/20 
      rounded-xl sm:shadow-xl 
      p-6 max-w-4xl w-full
      ${className}
    `}>
      {children}
    </div>
  );
}